import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostPassiveAggressiveTextsKO() {
  const articleData = {
    title: '수동적 공격적인 텍스트에 대한 궁극적인 가이드',
    description: '당신을 좌절시키거나 짜증나게 하는 텍스트에 혼란스러우신가요? Toxic Detector의 AI 기반 감지로 수동적 공격적인 메시지를 식별하는 방법을 알아보세요.',
    slug: 'ultimate-guide-passive-aggressive-texts',
    publishDate: '2025-05-22',
    author: 'Toxic Detector 편집팀'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: '수동적 공격적인 텍스트란 무엇입니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '적대감, 비판 또는 좌절감을 간접적으로 전달하여 종종 수신자를 혼란스럽게 하거나 짜증나게 하는 텍스트입니다.'
      }
    }, {
      '@type': 'Question',
      name: '사람들은 왜 수동적 공격적인 메시지를 보냅니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '공개적인 대립 없이 분노를 표현하거나, 죄책감을 유발하거나, 조작하는 은밀한 방법인 경우가 많습니다.'
      }
    }, {
      '@type': 'Question',
      name: 'AI가 메시지에서 수동적 공격적인 행동을 감지할 수 있습니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '네. Toxic Detector는 어조, 문구, 이모티콘 사용, 응답 패턴 및 미묘한 비꼬는 말을 분석하여 조작적인 텍스트를 표시합니다.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/ko/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('링크가 클립보드에 복사되었습니다!');
    }
  };
  return <>
      <MetaTags title="수동적 공격적인 텍스트에 대한 궁극적인 가이드 — AI가 조작을 감지하는 방법 | ToxicDetector" description="당신을 좌절시키는 텍스트에 혼란스러우신가요? AI로 수동적 공격적인 메시지를 식별하는 방법을 알아보세요." keywords="수동적 공격적인 텍스트, 은밀한 수동적 공격적 행동, 텍스트 조작 패턴, AI 수동적 공격성 탐지기" canonical={`https://toxicdetector.com/ko/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/rgRp5kcuKrQdAWFQxfbcKt/file_0000000085487243beb3c848ebc5ef15.png" schema={[faqSchema, articleSchema]} data-id="element-8220" data-mp="zzjopt8oysh4" />
      <div className="flex flex-col w-full min-h-screen bg-[#fafaf9]" data-id="element-8221" data-mp="1ey3wpncjgyhd">
        <header className="bg-white border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm bg-white/95" data-id="element-8222" data-mp="3kpr2xbrct8ly">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-8223" data-mp="3goxe8g637ps0">
            <div className="flex items-center justify-between" data-id="element-8224" data-mp="3gqid2hzfpuvo">
              <Link to="/" className="text-2xl font-bold tracking-tight" data-id="element-8225" data-mp="36ls59vhcnwjj">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="기사 공유" data-id="element-8226" data-mp="3alatb04gwnql">
                <Share2 size={20} data-id="element-8227" data-mp="31rxpv48s23q9" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-12" data-id="element-8228" data-mp="2mym4duh1jv0h">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors" data-id="element-8229" data-mp="2rwnp0ju482e2">
            <ArrowLeft size={16} className="mr-2" data-id="element-8230" data-mp="2iumpthfbn69r" />
            홈으로 돌아가기
          </Link>

          <header className="mb-12" data-id="element-8231" data-mp="c4gipw3iotsu">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-8232" data-mp="c5hvq643fqd7">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-8233" data-mp="h1gn82kpxohu">
              <time dateTime={articleData.publishDate} data-id="element-8234" data-mp="2d661elnwijf6">
                {new Date(articleData.publishDate).toLocaleDateString('ko-KR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-8235" data-mp="1z5vajimld4u0">•</span>
              <span data-id="element-8236" data-mp="1u7tnynpyinds">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-8237" data-mp="1u9wpo50h24yc">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sJh1uV1DahBAgXTJX4idSp/1763121685117.jpg" alt="AI가 수동적 공격적인 문자 메시지 분석" className="w-full rounded-2xl shadow-lg" data-id="element-8238" data-mp="1pglghx86tc39" />
          </div>

          <div className="bg-white rounded-2xl p-7 border border-gray-200 mb-12" data-id="element-8239" data-mp="1fkqpadpwe8ov">
            <h2 className="font-bold text-lg mb-5" data-id="element-8240" data-mp="1bgstabvvde01">목차</h2>
            <ol className="space-y-3 text-sm list-decimal list-inside" data-id="element-8241" data-mp="16hpmalwbwxpf">
              <li data-id="element-8242" data-mp="16klledjwxsfg">
                <a href="#sure-whatever" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-8243" data-mp="3i5uqiw3fnxd7">
                  고전적인 "그래, 뭐든지"
                </a>
              </li>
              <li data-id="element-8244" data-mp="3r7c70fkr612f">
                <a href="#backhanded-compliment" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-8245" data-mp="3r6spv12xfgpg">
                  비꼬는 칭찬
                </a>
              </li>
              <li data-id="element-8246" data-mp="2zda5g0tz6wjy">
                <a href="#friendly-reminder" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-8247" data-mp="33g6qrzawh6rl">
                  사실은 공격인 "친절한 알림"
                </a>
              </li>
              <li data-id="element-8248" data-mp="3d79r2yw09hpt">
                <a href="#ghostly-reply" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-8249" data-mp="3d7t17tfez1ta">
                  유령 같은 답장
                </a>
              </li>
              <li data-id="element-8250" data-mp="3o14its7k0nru">
                <a href="#sarcasm-humor" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-8251" data-mp="3o0kxs2mlxj9l">
                  유머로 위장한 비꼬기
                </a>
              </li>
              <li data-id="element-8252" data-mp="mqrlbhzqs6u">
                <a href="#conditional-niceness" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-8253" data-mp="n8vmuawaapb">
                  조건부 친절
                </a>
              </li>
              <li data-id="element-8254" data-mp="3035jkwfpu361">
                <a href="#rollercoaster" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-8255" data-mp="303ozy8ppwjhy">
                  왔다 갔다 롤러코스터
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg prose-gray max-w-none" data-id="element-8256" data-mp="395yct58gkoyi">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-8257" data-mp="tbehxlhlk7r9">
              짜증나거나 좌절하거나 혼란스럽게 만들었음에도 불구하고 과민
              반응하는 것인지 의문이 들게 만드는 문자를 받은 적이 있나요? 그것이{' '}
              <strong data-id="element-8258" data-mp="wu3s85lyysrj">수동적 공격적인 텍스트</strong>입니다.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-8259" data-mp="wwzu250xu1l9">
              저희 <strong data-id="element-8260" data-mp="10xrzsoalpocs">AI 감지</strong>는 이러한{' '}
              <strong data-id="element-8261" data-mp="mwpfafz98m3z">조작적인 행동</strong> 패턴을 즉시 포착할 수 있습니다.
              여기 궁극적인 가이드가 있습니다.
            </p>

            <section id="sure-whatever" className="mb-12" data-id="element-8262" data-mp="rv0n6l5zomjk">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-8263" data-mp="rxmwoqcfxc4f">
                1️⃣ 고전적인 "그래, 뭐든지"
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-8264" data-mp="1kk7uo9nf8mgy">
                <p className="italic text-gray-700 text-lg" data-id="element-8265" data-mp="15vbhjy6icj9h">
                  "그래, 네가 행복하다면 뭐든지..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8266" data-mp="1atd08i00ugkf">
                언뜻 보기에는 동의하는 것처럼 보이지만 그 밑에는? 무시나
                비꼬기가 있습니다. AI는 이러한 문구를 표시합니다.
              </p>
            </section>

            <section id="backhanded-compliment" className="mb-12" data-id="element-8267" data-mp="23bqwwe9mfwhx">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-8268" data-mp="386c46utplyd">
                2️⃣ 비꼬는 칭찬
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-8269" data-mp="3umvi5jq2inmx">
                <p className="italic text-gray-700 text-lg" data-id="element-8270" data-mp="3pniuwxvabejt">
                  "와, 네가 실제로 그걸 해냈네... 잘됐네."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8271" data-mp="3loa3hznpvsrf">
                좋게 들리나요? 사실 그렇지 않습니다. 이런 은밀한 공격은 자신감을
                깎아내립니다.
              </p>
            </section>

            <section id="friendly-reminder" className="mb-12" data-id="element-8272" data-mp="h8qtcyl3b9pr">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-8273" data-mp="d646lc3a0ezf">
                3️⃣ 사실은 공격인 "친절한 알림"
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-8274" data-mp="86r9lyioxrj4">
                <p className="italic text-gray-700 text-lg" data-id="element-8275" data-mp="2xxw7jy20h9rk">
                  "그냥 알려주는 건데... 내가 부엌 전체를 청소했어."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8276" data-mp="2t04gf696xrof">
                수동적 공격적인 텍스트는 종종 비판을 유용한 정보로 위장합니다.
              </p>
            </section>

            <section id="ghostly-reply" className="mb-12" data-id="element-8277" data-mp="1dflp67ocbnqx">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-8278" data-mp="1hfvwpors6m7w">
                4️⃣ 유령 같은 답장
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-8279" data-mp="1m7e1knwxd6y5">
                <p className="italic text-gray-700 text-lg" data-id="element-8280" data-mp="1r70boohgi72q">
                  "ㅇㅇ..." 또는 답장 없음
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8281" data-mp="1w3qsxf4zz8pq">
                짧거나 지연되거나 누락된 응답은 대면 없이 처벌할 수 있습니다.
              </p>
            </section>

            <section id="sarcasm-humor" className="mb-12" data-id="element-8282" data-mp="2569rhn1r2z66">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-8283" data-mp="253nl3qqlippj">
                5️⃣ 유머로 위장한 비꼬기
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-8284" data-mp="arpabkcn1lrj">
                <p className="italic text-gray-700 text-lg" data-id="element-8285" data-mp="2s244er4nmqpx">
                  "오, 넌 정말 똑똑하구나 😏"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8286" data-mp="2w4qw8s1bsbn4">
                은밀한 비꼬기는 핵심 도구입니다. 저희 AI는 맥락을 포착합니다.
              </p>
            </section>

            <section id="conditional-niceness" className="mb-12" data-id="element-8287" data-mp="361vnh6a12xas">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-8288" data-mp="3636sf9f7mb3h">
                6️⃣ 조건부 친절
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-8289" data-mp="3az5kb6zqyb8n">
                <p className="italic text-gray-700 text-lg" data-id="element-8290" data-mp="3f0h0yn0n7m4p">
                  "도와줄게... 약속이 없다면."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8291" data-mp="3oswi5i4486oj">
                수동적 공격적인 사람은 죄책감을 유발하기 위해 경계를 설정합니다.
              </p>
            </section>

            <section id="rollercoaster" className="mb-12" data-id="element-8292" data-mp="3tpd9el6m315u">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-8293" data-mp="2m81cfdcpmfi">
                7️⃣ 왔다 갔다 롤러코스터
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-8294" data-mp="1n4s8xr48tbks">
                <p className="italic text-gray-700 text-lg" data-id="element-8295" data-mp="1i2jh4y33wfk9">
                  텍스트에서의 극단적인 고저
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8296" data-mp="1d6unfbdrpsvv">
                변동하는 어조는 조작적인 행동의 위험 신호입니다.
              </p>
            </section>

            <section className="mb-12" data-id="element-8297" data-mp="25sdrn8zyds1c">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-8298" data-mp="25vjiaso8d1z6">
                🛡 자신을 보호하는 방법
              </h2>
              <ul className="space-y-4 text-lg text-gray-600" data-id="element-8299" data-mp="1w3m4de5u7vwr">
                <li className="flex items-start gap-3" data-id="element-8300" data-mp="1w22kldkz32q8">
                  <span className="text-gray-900 font-bold" data-id="element-8301" data-mp="1r5kloucbpylt">•</span>
                  <span data-id="element-8302" data-mp="2ok6m77uo7lb6">직감을 믿으세요.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-8303" data-mp="2olrf6t1c6w6x">
                  <span className="text-gray-900 font-bold" data-id="element-8304" data-mp="2jsy9o2y1njts">•</span>
                  <span data-id="element-8305" data-mp="2jrn889s2mo5u">스크린샷을 보관하세요.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-8306" data-mp="hx8xjivyap4m">
                  <span className="text-gray-900 font-bold" data-id="element-8307" data-mp="mur97h1crigb">•</span>
                  <span data-id="element-8308" data-mp="mx3o1lbtdcp5">개별 텍스트를 과도하게 분석하지 마세요.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-8309" data-mp="85biu25qhf15">
                  <span className="text-gray-900 font-bold" data-id="element-8310" data-mp="d4xzymoonff8">•</span>
                  <span data-id="element-8311" data-mp="d34omu34k70w">Toxic Detector를 사용하세요.</span>
                </li>
              </ul>
            </section>

            <section className="mb-16" data-id="element-8312" data-mp="3vd6ujnr6wvbw">
              <h2 className="text-3xl font-bold mb-8 tracking-tight" data-id="element-8313" data-mp="3831g3setf0y">
                자주 묻는 질문
              </h2>
              <div className="space-y-6" data-id="element-8314" data-mp="3ldy59879s4vv">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-8315" data-mp="3qc9gnnd7qng7" data-mpi={index}>
                    <h3 className="font-bold text-lg mb-3 text-gray-900" data-id="element-8316" data-mp="1ok4kfzool3zo">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-8317" data-mp="3936wuwgawfoh">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-gray-900 rounded-2xl p-12 text-center text-white mt-16" data-id="element-8318" data-mp="3iubbfv22dyis">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-8319" data-mp="3e0743aovzoh6">
              💀 해독을 멈추세요. 알기 시작하세요.
            </h2>
            <p className="text-gray-300 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-8320" data-mp="3rupv6pzdr5k6">
              추측은 그만하세요. 텍스트를 Toxic Detector에 업로드하고 즉시 독성
              점수를 받으세요.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-8321" data-mp="5jlze63afhjv">
              <p className="font-bold text-xl" data-id="element-8322" data-mp="kr8shz2wop7">
                "🚩 65% 수동적 공격성 감지 — 반복되는 무시 행동 발견!"
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-gray-900 px-10 py-4 rounded-xl font-bold text-lg hover:bg-gray-100 transition-colors" data-id="element-8323" data-mp="22ei3b0cyjglf">
              지금 채팅 스캔하기 →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: '당신의 전 애인은 내현적 나르시시스트입니까?',
          description: '텍스트 분석을 통해 전 애인이 내현적 나르시시스트 행동의 징후를 보이는지 알아보세요.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }, {
          title: '용어 배우기: 나르시시즘 & 가스라이팅',
          description: '관계에서의 나르시시즘과 가스라이팅 패턴을 이해하세요.',
          slug: 'narcissism-gaslighting-explained',
          emoji: '💀'
        }]} data-id="element-8324" data-mp="yi7nv0e4gi5a" />

          <div className="mt-12 text-center" data-id="element-8325" data-mp="ok1oapfsfo3l">
            <button onClick={handleShare} className="inline-flex items-center text-gray-700 hover:text-gray-900 font-medium transition-colors" data-id="element-8326" data-mp="3o5yhvn94rj46">
              <Share2 size={18} className="mr-2" data-id="element-8327" data-mp="3kn96ezt0us2b" />이 기사 공유하기
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-12 mt-16" data-id="element-8328" data-mp="3fnwj6dy8niz7">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-8329" data-mp="3fmljoqbtsxdw">
            <p className="text-gray-400 text-sm" data-id="element-8330" data-mp="3bl9pe7i0bnzd">
              © {new Date().getFullYear()} ToxicDetector. 전권 소유.
            </p>
          </div>
        </footer>
      </div>
    </>;
}